// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyDl3AoBXvAXVR9e6fOItY2NI61vtlp2P1Q",
    authDomain: "mid-point-beta.firebaseapp.com",
    databaseURL: "https://mid-point-beta.firebaseio.com",
    projectId: "mid-point-beta",
    storageBucket: "mid-point-beta.appspot.com",
    messagingSenderId: "1059754215676",
    appId: "1:1059754215676:web:7239c582bf73ed25"
  },
  //api: 'https://www.advantask.com/frontend_dev.php/api',
  api: 'https://api.midpointfx.com/api',
  app: 'https://webapp.midpointfx.com/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
